import React from "react";
import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import Seo from "../components/Seo";
import { Button } from "../components/ui/button";

export default function PaymentCancel() {
  return (
    <main className="flex min-h-[80vh] items-center justify-center bg-slate-50 px-5 py-12">
      <Seo title="Payment cancelled | FindMyFlight" description="Your FindMyFlight PRO checkout was cancelled." path="/payment/cancel" />
      <div className="w-full max-w-md rounded-2xl border border-slate-200 bg-white p-8 text-center shadow-sm">
        <XCircle className="mx-auto h-14 w-14 text-slate-300" />
        <h1 className="mt-4 text-2xl font-bold text-slate-900">Checkout cancelled</h1>
        <p className="mt-2 text-sm text-slate-600">No worries — you haven’t been charged. You can upgrade to PRO anytime.</p>
        <div className="mt-6 flex justify-center gap-2">
          <Link to="/pricing"><Button className="bg-blue-600 hover:bg-blue-700">Back to pricing</Button></Link>
          <Link to="/"><Button variant="outline">Home</Button></Link>
        </div>
      </div>
    </main>
  );
}
